import { Form, FormItemProps, Select } from 'antd';
import React, { ReactElement } from 'react';
import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { testId } from 'leash/utilities/test/dataTestId';
import { TransporterCompany } from 'types';

const { Option } = Select;

interface Props extends FormItemProps<string> {
  placeholder?: string;
  onChange?: (e: number) => void;
  disabled?: boolean;
  loading?: boolean;
}

export function FieldGroundTransporter(props: Props): ReactElement | null {
  if (!LeashContent?.groundTransportationCompanies) return null;
  const {
    name,
    label,
    placeholder,
    onChange = () => 0,
    disabled,
    loading,
    style,
  } = props;

  return (
    <Form.Item
      name={name ?? 'groundTransporter'}
      label={label ?? 'Transporter'}
      rules={[{ required: true, message: 'Select a ground transporter' }]}
      data-testid={testId.fieldGroundTransporter}
      style={style}
    >
      <Select
        showSearch
        placeholder={placeholder ?? 'Select a ground transporter'}
        optionFilterProp="children"
        filterOption={(input, option) => {
          return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0;
        }}
        onChange={onChange}
        disabled={disabled}
        loading={loading}
      >
        {LeashContent.groundTransportationCompanies.map(
          (t: TransporterCompany, idx: number) => (
            <Option
              value={t.id}
              key={t.id}
              data-testid={`${testId.fieldGroundTransporterOption}${idx}`}
            >
              {t.name}
            </Option>
          ),
        )}
      </Select>
    </Form.Item>
  );
}
